export default (url, params) =>
  new Promise(resolve => {
    var head = document.getElementsByTagName("head")[0];
    var script = document.createElement("script");
    script.type = "text/javascript";
    const paramStr = Object.keys(params)
      .map(v => `${v}=${params[v]}`)
      .join("&");

    script.src = `${url}?${paramStr}`;
    // 借鉴了jQuery的script跨域方法
    script.onload = script.onreadystatechange = function() {
      if (
        !this.readyState ||
        this.readyState === "loaded" ||
        this.readyState === "complete"
      ) {
        resolve();
        script.onload = script.onreadystatechange = null;
      }
    };
    head.insertBefore(script, head.firstChild);
  });
